import * as Yup from 'yup';
import baseAccidentInfoSchemaSchema from '../accidentInfoSchema';
import accidentAddressSchema from '../accidentAddressSchema';

const accidentInfoSchema = Yup.object().shape({
  accidentTime: Yup.string()
    .nullable()
    .required('validationErrors.isRequired'),
}).concat(baseAccidentInfoSchemaSchema).concat(accidentAddressSchema);

export default accidentInfoSchema;
